import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "@repo/ui";

import { isCreateDoubtQuotaExhaustedError } from "./createDoubtResponse";

export function useDoubtErrorToast() {
  const { toast } = useToast();
  const { t } = useTranslation("doubts");

  const showSomethingWentWrong = useCallback(
    (error?: unknown): boolean => {
      if (isCreateDoubtQuotaExhaustedError(error)) {
        return false;
      }
      toast({
        status: "error",
        title: t("something_went_wrong"),
        duration: 4000,
      });
      return true;
    },
    [toast, t],
  );

  return { showSomethingWentWrong };
}
